export const EarlyWarningRouting = [
  {
    path: "/maintenance/earlyWarning",
    name: "maintenance-early-warning-list",
    meta: { title: "预警管理" },
    component: () =>
      import(
        /* webpackChunkName: "maintenance-early-warning" */ "@/views/maintenance/early-warning/list/index.vue"
      ),
  },
];
